import { Mui, MuiX, DateFns } from '@osu/react-ui'; 
import { useState } from 'react';
import MenuDialogBase from "./MenuDialogBase";
import { useGetApplicationDetailsQueryState, useApplicationReassignReviewMutation } from "../../../services/graphql/api";
import { getApplDetailParams, addBusinessDays } from "../../../util/functions";

export default function DialogReassign({ menuItemAndClose }) {
    const params = getApplDetailParams();
    const { data } = useGetApplicationDetailsQueryState(params);
    const reviewersFrom = data?.configuration.unassignableReviewers ?? [];
    const reviewersTo = data?.configuration.assignableReviewers ?? [];

    const [apiCall, result] = useApplicationReassignReviewMutation();
    const [reviewerFrom, setReviewerFrom] = useState(null);
    const [reviewerTo, setReviewerTo] = useState(null);
    const [completedByDueDate, setCompletedByDueDate] = useState(addBusinessDays(new Date(), 5));

    const variables = { reviewerEmployeeIdFrom: reviewerFrom?.id, reviewerEmployeeIdTo: reviewerTo?.id, completedByDueDate, ...params };
    const isDisabled = !reviewerFrom || !reviewerTo || isNaN(completedByDueDate);
    const buttons = [{ label: "Re-assign", apiCall, variables, isDisabled }];
    const message = `You are re-assigning from ${reviewerFrom?.name ?? "a reviewer"} to ${reviewerTo?.name ?? "a reviewer"} for this applicant.`;

    return (
        <MenuDialogBase menuItemAndClose={menuItemAndClose}
            apiCall={apiCall}
            buttons={buttons}
            result={result}
            extraContent={(
                <>
                    {message}
                
                    <br/>
                    <br/>
                    
                    <Mui.FormControl fullWidth required>
                        <Mui.InputLabel id="dialog-unassign-choose-reviewer">Choose Reviewer</Mui.InputLabel>
                        <Mui.Select
                            disabled={result?.isLoading || result.isSuccess}
                            sx={{ width: "100%", marginBottom: "0.5em" }}
                            label="Choose Reviewer"
                            labelId="dialog-unassign-choose-reviewer"
                            value={reviewerFrom?.id ?? ""}
                            onChange={event => setReviewerFrom(reviewersFrom.find(r => r.id === event.target.value))}>
                                {reviewersFrom.map((item, index) => <Mui.MenuItem key={index} value={item.id}>{item.name}</Mui.MenuItem>)}
                        </Mui.Select>
                    </Mui.FormControl>
                    
                    <br/>
                    
                    <Mui.FormControl fullWidth required>
                        <Mui.InputLabel id="dialog-assign-choose-reviewer">Choose Reviewer</Mui.InputLabel>
                        <Mui.Select
                            disabled={result?.isLoading || result.isSuccess}
                            sx={{ width: "100%" }}
                            label="Choose Reviewer"
                            labelId="dialog-assign-choose-reviewer"
                            value={reviewerTo?.id ?? ""}
                            onChange={event => setReviewerTo(reviewersTo.find(r => r.id === event.target.value))}>
                                {reviewersTo.map((item, index) => <Mui.MenuItem key={index} value={item.id}>{item.name}</Mui.MenuItem>)}
                        </Mui.Select>
                    </Mui.FormControl>
                    
                    <DateFns.LocalizationProvider>
                        <MuiX.DatePicker
                            disabled={result?.isLoading || result.isSuccess}
                            disablePast={true}
                            label="Complete By *"
                            value={completedByDueDate}
                            onChange={setCompletedByDueDate}
                            sx={{ marginTop: "1em", width: "100%" }}
                            required
                        />
                    </DateFns.LocalizationProvider>
                </>
            )}
        />
    );
}